import React from 'react'
import './Error.css'

const Error = () => {
  return (
    <div className="error-container">
      Error - 404 Not found
    </div>
  )
}

export default Error
